import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';

import axios from "axios";
import {Button, Col, Form, InputGroup, Row} from "react-bootstrap";
import TimePicker from 'react-bootstrap-time-picker';
import {VitalsConfigureView} from "./VitalsConfigureView";


export const ClientConfig = (props: { cookieQr: string }) => {

    const [sessionDetails, setSessionDetails] = useState<Array<any>>([])

    const [addSessionDay, setAddSessionDay] = useState("MON")
    const [addStartTime, setAddStartTime] = useState(18000)
    const [addEndTime, setAddEndTime] = useState(21600)
    const [futureAppointments, setFutureAppointments] = useState(false)
    const [callPaidNext, setCallPaidNext] = useState(false)
    const [onlineAppointments, setOnlineAppointments] = useState(false)
    const [printPatientDetails, setPrintPatientDetails] = useState(true)
    const [standardFollowUp, setStandardFollowUp] = useState("5")
    const [consultationFee, setConsultationFee] = useState<string>()
    const [topMargin, setTopMargin] = useState<string>()
    const [bottomMargin, setBottomMargin] = useState<string>()
    const [leftMargin, setLeftMargin] = useState<string>()
    const [vitalsToCollect, setVitalsToCollect] = useState<Array<string>>([])
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)

    useEffect(() => {
        if (props.cookieQr) {
            axios.get('/api/backend/client/config/fetch/' + props.cookieQr)
                .then(resp => {
                    if (resp.data) {
                        setSessionDetails(JSON.parse(resp.data.sessions))
                        setFutureAppointments(resp.data.futureAppointments)
                        setCallPaidNext(resp.data.callPaidNext)
                        setConsultationFee(resp.data.consultationFee)
                        setOnlineAppointments(resp.data.qmeActive)
                        setPrintPatientDetails(resp.data.printPatientDetails)
                        setVitalsToCollect(JSON.parse(resp.data.vitals))
                        setStandardFollowUp(resp.data.followUpAfter)
                        const templateSettings = JSON.parse(resp.data.templateSetting)
                        if (templateSettings) {
                            setLeftMargin(templateSettings.leftMargin)
                            setTopMargin(templateSettings.topMargin)
                            setBottomMargin(templateSettings.bottomMargin)
                        }
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
                .finally(() => {
                })
        }
    }, [props.cookieQr])

    const handleSaveConfigurations = () => {
        setError(null)
        setSuccess(null)
        const headers = {headers: {"Content-Type": "application/json"}};
        axios.post('/api/backend/client/config/save', {
            futureAppointments: futureAppointments,
            callPaidNext: callPaidNext,
            qmeActive: onlineAppointments,
            printPatientDetails: printPatientDetails,
            followUpAfter: standardFollowUp,
            vitals: JSON.stringify(vitalsToCollect),
            consultationFee: Number.parseFloat(consultationFee),
            templateSetting: JSON.stringify({leftMargin: leftMargin, topMargin: topMargin, bottomMargin: bottomMargin}),
            qr: props.cookieQr,
            sessions: JSON.stringify(sessionDetails)
        }, headers).then(resp => {
            setSuccess("* Successfully updated the configurations")
        })
            .catch(err => {
                setError("* Something went wrong")
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
            .finally(() => {
            })
    }

    const handleAddSession = () => {
        let day = sessionDetails.filter(s => s.name == addSessionDay).at(0)
        const updatedDay = day ? day : {
            name: addSessionDay,
            sessions: []
        }
        let newSession = {
            startTime: addStartTime,
            endTime: addEndTime
        }


        if (updatedDay.sessions && updatedDay.sessions.filter(s => s.startTime == newSession.startTime && s.endTime == newSession.endTime).length > 0) {
            return
        }

        updatedDay.sessions.push(newSession)
        const updatedSessionDetails = sessionDetails.filter(s => s.name != addSessionDay)
        updatedSessionDetails.push(updatedDay)
        setSessionDetails(updatedSessionDetails)
        console.log(JSON.stringify(sessionDetails))
    }

    const handleRemoveSession = (removeDay: String, removeStartTime: String, removeEndTime: String) => {
        let updatedDay = sessionDetails.filter(s => s.name == removeDay).at(0)
        const updatedSessions = updatedDay.sessions.filter(s => !(s.startTime == removeStartTime && s.endTime == removeEndTime))

        updatedDay.sessions = updatedSessions
        const updatedSessionDetails = sessionDetails.filter(s => s.name != removeDay)
        if (updatedSessions && updatedSessions.length > 0) {
            updatedSessionDetails.push(updatedDay)
        }
        setSessionDetails(updatedSessionDetails)
        console.log(JSON.stringify(sessionDetails))
    }


    function getDaySessions(day: any) {
        return <>
            <Row className="bg-light py-1">
                <Col>
                    <div className="font-weight-bold text-info">{day.name}</div>
                </Col>
            </Row>
            <Row className="py-1">
                <Col>
                    {day.sessions && (day.sessions as Array<any>).map(session => {
                        return <>
                            <div className="d-flex justify-content-between my-1">
                                <div className="align-self-center">Start</div>
                                &nbsp;
                                <TimePicker value={session.startTime} disabled size={"sm"}/>&nbsp;
                                <div className="align-self-center">End</div>
                                &nbsp;
                                <TimePicker value={session.endTime} disabled size={"sm"}/>&nbsp;
                                <Button
                                    className="btn btn-outline-danger text-danger font-weight-bold bg-white"
                                    size="sm"
                                    onClick={() => handleRemoveSession(day.name, session.startTime, session.endTime)}
                                >
                                    X
                                </Button>
                            </div>
                        </>
                    })
                    }
                </Col>
            </Row>
        </>;
    }

    function getAddSessionForm() {
        return <Row className="pt-4">
            <Col>
                <Row>
                    <Col>
                        <div className="form-control">
                            <select className="form-select form-select-sm my-3"
                                    value={addSessionDay}
                                    onChange={e => setAddSessionDay(e.target.value)}
                            >
                                <option value="MON">Monday</option>
                                <option value="TUE">Tuesday</option>
                                <option value="WED">Wednesday</option>
                                <option value="THU">Thursday</option>
                                <option value="FRI">Friday</option>
                                <option value="SAT">Saturday</option>
                                <option value="SUN">Sunday</option>
                                <option value="ALL">All Days</option>
                                <option value="WEEKDAYS">Week days</option>
                                <option value="MON-SAT">Monday to Saturday</option>
                                <option value="WEEKENDS">Weekends</option>
                            </select>
                            <div className="d-flex justify-content-between my-3">
                                <div className="align-self-center fs-7 text-info">Start:&nbsp;</div>
                                <TimePicker start="01:00" end="23:30" step={30} value={addStartTime} size={"sm"}
                                            onChange={setAddStartTime}/>
                                <div className="align-self-center fs-7 text-info">&nbsp;End:&nbsp;</div>
                                <TimePicker start="01:00" end="23:30" step={30} value={addEndTime} size={"sm"}
                                            onChange={setAddEndTime}/>&nbsp;
                            </div>
                            <div className="my-3">
                                <Button
                                    className="btn btn-warning text-white font-weight-bold"
                                    size="sm"
                                    onClick={handleAddSession}
                                >
                                    Add Session Timing
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>;
    }

    return (
        <>
            <Row>
                <Col>
                    <h5 className="text-primary mb-4 text-decoration-underline">Session Timings</h5>
                    <div className="fs-7 text-info">
                        {sessionDetails && sessionDetails.length > 0 && sessionDetails.map(day => {
                            return getDaySessions(day)
                        })
                        }
                        {!sessionDetails || sessionDetails.length == 0 &&
                            <div className="font-italic">Timings not provided yet.</div>
                        }
                    </div>
                    <div>
                        {getAddSessionForm()}
                    </div>

                    <div>
                        <h5 className="text-primary my-4 text-decoration-underline">Other Configurations</h5>
                        <Form className="fs-7 text-info">
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                checked={futureAppointments}
                                className="my-2"
                                onChange={e => setFutureAppointments(e.target.checked)}
                                label="Enable Future date Appointments"
                            />
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                className="my-2"
                                checked={callPaidNext}
                                onChange={e => setCallPaidNext(e.target.checked)}
                                label="Skip Unpaid Patients"
                            />
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                className="my-2"
                                checked={onlineAppointments}
                                onChange={e => setOnlineAppointments(e.target.checked)}
                                label="Enable Online Appointments"
                            />
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                className="my-2"
                                checked={printPatientDetails}
                                onChange={e => setPrintPatientDetails(e.target.checked)}
                                label="Print Patient Details on Prescription"
                            />
                            <hr/>
                            <Form.Group as={Row} className="my-3" controlId="consultationFee">
                                <Form.Label className="text-info" column sm={6}><img
                                    alt="session-management"
                                    src="/emr/reminder.png"
                                    width="20"
                                    height="20"
                                />&nbsp;&nbsp;Standard Follow-up Reminder</Form.Label>
                                <Col sm={6}>
                                    <div>
                                        <InputGroup className="">
                                            <input className="form-control form-control-sm" type="number"
                                                   onChange={e => setStandardFollowUp(e.target.value)}
                                                   value={standardFollowUp}/>&nbsp;&nbsp;
                                            Days
                                        </InputGroup>
                                    </div>
                                </Col>
                            </Form.Group>
                            <hr/>
                            <div className="text-info my-4 fs-6">Vitals To be Collected</div>
                            <VitalsConfigureView vitals={vitalsToCollect} updateVitals={setVitalsToCollect}/>
                            <hr/>
                            <Form.Group as={Row} className="my-3" controlId="consultationFee">
                                <Form.Label className="fs-6" column sm={6}>Consultation Fee in ₹:</Form.Label>
                                <Col sm={6}>
                                    <Form.Control value={consultationFee} size={"sm"}
                                                  onChange={e => setConsultationFee(e.target.value)}
                                                  name="consultationFee" type="number" className="d-inline-block"
                                                  placeholder="Enter Consultation Fee"/>
                                </Col>
                            </Form.Group>
                            <hr/>
                            <Form.Group className="my-3" controlId="templateSettings">
                                <Form.Label className="fs-6">Prescription Printing Template Settings:</Form.Label>
                                <Form.Group as={Row} className="my-2" controlId="left-margin">
                                    <Form.Label column sm={6}>Left-Margin in pixels:</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control value={leftMargin} onChange={e => setLeftMargin(e.target.value)}
                                                      size={"sm"}
                                                      name="leftMargin" type="text" className="my-2"
                                                      placeholder="Enter left margin"/>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="my-2" controlId="top-margin">
                                    <Form.Label column sm={6}>Top-Margin in pixels:</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control value={topMargin} onChange={e => setTopMargin(e.target.value)}
                                                      size={"sm"}
                                                      name="topMargin" type="text" className="my-2"
                                                      placeholder="Enter top margin"/>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="my-2" controlId="bottom-margin">
                                    <Form.Label column sm={6}>Bottom-Margin in pixels:</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control value={bottomMargin}
                                                      onChange={e => setBottomMargin(e.target.value)}
                                                      size={"sm"}
                                                      name="bottomMargin" type="text" className="my-2"
                                                      placeholder="Enter bottom margin"/>
                                    </Col>
                                </Form.Group>
                            </Form.Group>
                        </Form>
                    </div>
                </Col>
            </Row>
            <Row className="pt-4">
                <Col>
                    <Button
                        className="btn btn-info text-white "
                        onClick={handleSaveConfigurations}
                    >
                        Save Configurations
                    </Button>
                    {success &&
                        <div className="text-success fs-5">{success}</div>
                    }
                    {error &&
                        <div className="text-danger fs-5">{error}</div>
                    }
                </Col>
            </Row>
        </>
    );
};
